import React from 'react';
import { ViewType } from '../../types';

interface GridLineProps {
  left: number;
  width: number;
  height: string;
  isHoliday?: boolean;
  isWeekend?: boolean;
  isMonthBoundary?: boolean;
  viewType?: ViewType;
}

export const GridLine: React.FC<GridLineProps> = ({
  left,
  width,
  height,
  isHoliday = false,
  isWeekend = false,
  isMonthBoundary = false,
  viewType
}) => {
  const getBorderWidth = () => {
    if (viewType === 'yearly' || viewType === 'quarterly') {
      return '1px';
    }
    if(isHoliday || isWeekend) return '2px';
    return '2px';
  };

  const getOpacity = () => {
    if (viewType === 'yearly') {
      if(isMonthBoundary) {
        return 1; // Month boundaries fully visible
      } else if(isWeekend) {
        return 0.2; // Week boundaries (every 4th column) slightly visible
      } else {
        return 0.05; // Regular days very faint
      }
    }

    if (viewType === 'quarterly') {
      if(isHoliday || isWeekend) {
        return 1
      } else {
        return 0.05
      }
    }

    if (isMonthBoundary || isHoliday || isWeekend) {
      return 1;
    }

    return 0.3;
  };

  let borderColorClass = '';
  if (isHoliday && viewType !== 'yearly') {
    borderColorClass = 'border-r-orange-500 dark:border-r-[#fe5a1e]';
  } else if (viewType === 'yearly' && isMonthBoundary) {
    borderColorClass = 'border-r-gray-300 dark:border-r-[#2d3748]';
  } else if (viewType === 'yearly' && isWeekend) {
    // In yearly view, isWeekend represents every 4th column (week boundaries)
    borderColorClass = 'border-r-gray-300/50 dark:border-r-[#2a3244]';
  } else if (isWeekend) {
    borderColorClass = 'border-r-gray-300 dark:border-r-[#3B465B]';
  } else {
    borderColorClass = 'border-r-gray-200 dark:border-r-[#3B465B]';
  }

  return (
    <div
      className={`absolute border-r ${borderColorClass}`}
      style={{
        left: `${left}px`,
        width: `${width}px`,
        zIndex: 0,
        height,
        top: 0,
        borderRightWidth: getBorderWidth(),
        borderRightStyle: 'solid',
        opacity: getOpacity(),
        pointerEvents: 'none'
      }}
    />
  );
}; 